<template>
  <fieldset class="input-field price-field" :class="{'active': isActive, 'small':small}">

    <legend v-if="label">{{ label }}</legend>
    <div class="layout-row flex">
      <div class="icon">
        <span class="currency-symbol">{{getSymbol}}</span>
      </div>
      <input type="number"
             v-bind="$attrs"
             @input="$emit('input', $event.target.value)"
             class=" "
             min="0"
             max="9999999999999"
             step="1"
             :class="{ 'is-invalid': hasError }"
             @change="editNumber($event)"
             @blur="isActive=false, wasActive=true"
             @focus="isActive=true">
    </div>

    <p v-if="hasError" class="validation-message">
        {{ error }}
    </p>
  </fieldset>
</template>

<script>
    import {mapGetters} from "vuex";
    import currencies from "@/helpers/currencies";

    export default {
        inheritAttrs: false,
        name: "PriceField",

      data: function (){
          return {
            wasActive: false,
            isActive: false,
          }
      },
        props: {
          currencyCode: {
            type: String,
            default: 'USD',
          },
          label: String,
	        small: Boolean,
          error: {
              default: () => null
          },
        },
      methods: {
        editNumber(event) {
          isNaN(event.target.value) ? event.target.value = 0 : '';
          // event.target.value = parseFloat(event.target.value);
        },
      },
      computed: {
        ...mapGetters(["getAutomationData", "ifError", 'getFunnelStore']),
        getSymbol() {
          let target = currencies.find(item => item.id === this.currencyCode);
          if (target) {
            return target.symbol
          } else {
            return "$"
          }
        },
        hasError() {
            return !!this.error && this.wasActive;
        }
      }
    };
</script>
<style lang="scss">
fieldset.price-field {

  border: 2px solid #E4E6F1;
  border-radius: 8px;
  height: 41px;
  position: relative;
  transition: 0.15s all ease-in-out;
  display: flex;
  padding: 3px 4px 2px;

	&.small {
		height: 28px;
		border: 1px solid #E4E6F1;
		border-radius: 5px;
		legend {
			font-size: 11px;
			top: -13px;
		}
		.icon {
			span.currency-symbol {
				height: 18px;
				//min-width: 18px;
			}
		}
	}
  legend {
    position: absolute;
    left: 8px;
    top: -11px;
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
    letter-spacing: 0.02em;
    color: #C5C7D2;
    padding: 0 5px;
    display: flex;
    align-items: center;
    z-index: 2;
    background-color: #fff;
  }

  &:last-child {
    margin-bottom: 0;
  }

  input, .value {
    position: relative;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: transparent;
    border: none;
    padding: 0 15px;
    display: flex;
    align-items: center;
    font-size: 14px;
    letter-spacing: 0.02em;
    color: #636A7B;
    margin-left: 5px;
  }
  .value {
    color: #C5C7D2;
    pointer-events: none;
  }
  .text {
    padding-left: 150px;
  }
  &.active {
    border-color: #4368E0;

    legend {
      color: #4368E0;
    }
    .icon {
      .currency-symbol {
        background: #4268df;
      }
    }
  }
  .icon {
    vertical-align: middle;
    top: 50%;
    transform: translateY(-50%);
    left: 4px;
    position: relative;
    height: fit-content;

    span.currency-symbol {
      display: flex;
      height: 20px;
      align-items: center;
      justify-content: center;
      text-align: center;
      background-color: #c5c7d2;
      border-radius: 12px;
      color: #fff;
      font-weight: 700;
      min-width: 20px;
      width: auto;
      padding: 0 5px;
    }
  }

  &:not(.active):hover {
    border: 2px solid #bfc3dc;
    legend {
      color: #bfc3dc;
    }
    .icon {
      .currency-symbol {
        background: #bfc3dc;
      }
    }
  }


}
</style>
